import {
    ADD_ANOTHER_OVERVIEW_ATTACHMENT, CHANGE_OVERVIEW_ATTACHMENT,
    CHANGE_OVERVIEW_POLICY_FIELD,
    CHANGE_OVERVIEW_TAB_READ_MORE_STATE,
    FAILED_TO_GET_APPLICATION_OVERVIEW,
    GET_OVERVIEW_TAB_TAGS_DESCRIPTION,
    GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL,
    GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS,
    OVERVIEW_POLICY_ATTACHMENTS_CHANGE,
    OVERVIEW_TAB_PAGE_SHIFT,
    RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM,
    RECEIVE_GET_APPLICATION_OVERVIEW,
    RECEIVE_GET_APPLICATION_READ_BY_ARAG,
    RECEIVE_POST_OVERVIEW_POLICY_FORM,
    REMOVE_OVERVIEW_ATTACHMENT,
    REQUEST_GET_APPLICATION_OVERVIEW,
    REQUEST_POST_OVERVIEW_POLICY_FORM
} from "./index";

export function changeOverviewAttachment(payload) {
    return {
        type: CHANGE_OVERVIEW_ATTACHMENT,
        payload: payload
    }
}

export function removeOverviewAttachment(payload) {
    return {
        type: REMOVE_OVERVIEW_ATTACHMENT,
        payload: payload
    }
}

export function addAnotherOverviewAttachment(payload) {
    return {
        type: ADD_ANOTHER_OVERVIEW_ATTACHMENT,
        payload: payload
    }
}

//action that requests the overview tab tags description
export function getOverviewTabTagsDescription() {
    return {
        type: GET_OVERVIEW_TAB_TAGS_DESCRIPTION
    }
}

//action that receives the overview tab tags description
export function getOverviewTabTagsDescriptionSuccess(payload) {
    return {
        type: GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS,
        payload: payload
    }
}

//action that receives error while trying to get the overview tab tags description
export function getOverviewTabTagsDescriptionFail(payload) {
    return {
        type: GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL,
        payload: payload
    }
}

export function requestGetApplicationOverview(id) {
	return {
		type: REQUEST_GET_APPLICATION_OVERVIEW,
		payload: id
	}
}

//action that receives GET questions
export function receiveGetApplicationOverview(overview) {
	return {
		type: RECEIVE_GET_APPLICATION_OVERVIEW,
		payload: overview
	}
}

export function receiveGetApplicationReadByArag(readByArag) {
	return {
		type: RECEIVE_GET_APPLICATION_READ_BY_ARAG,
		payload: readByArag
	}
}

//action  that receives failed request response from getting the application overview
export function failedToGetApplicationOverview(response) {
	return {
		type: FAILED_TO_GET_APPLICATION_OVERVIEW,
		payload: response
	}
}

export function changeOverviewPolicyField (field, value){
	return {
		type: CHANGE_OVERVIEW_POLICY_FIELD,
		payload: {
			key: field,
			value: value
		}
	}
}


export function requestPostOverviewPolicyForm(application) {
	return {
		type: REQUEST_POST_OVERVIEW_POLICY_FORM,
		payload: application
	}
}

export function receivePostOverviewPolicyFrom (response) {
	return {
		type: RECEIVE_POST_OVERVIEW_POLICY_FORM,
		payload: response
	}
}

export function receiveBadRequestPostOverviewPolicyForm(response) {
	return {
		type: RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM,
		payload: response
	}
}

//action that changes the required field data stored in redux
export function overviewPolicyAttachmentsChange( attachment) {
	return {
		type: OVERVIEW_POLICY_ATTACHMENTS_CHANGE,
		payload: attachment
	}
}


export function changeOverViewTabReadMoreState (key, value){
    return {
        type: CHANGE_OVERVIEW_TAB_READ_MORE_STATE,
        payload: {
            key: key,
            value: value
        }
    }
}

//action that shifts the page value +-1
export function overviewTabPageShift(direction, totalPaginationBoxes){
    return {
        type: OVERVIEW_TAB_PAGE_SHIFT,
        payload: {
            direction: direction,
            totalPaginationBoxes: totalPaginationBoxes
        }
    }
}
